import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import { IntlText } from "../util/Text";
import ArticleView from "../views/Article";

class ArticleCardsList extends Component {
  render = () => {
    if (this.props.articles == null) {
      return (
        <div className="uk-text-center">
          <span data-uk-spinner="ratio: 3"></span>
        </div>
      );
    } else if (this.props.articles.length <= 0) {
      return (
        <div>
          <h3>
            <IntlText id="lists.articles.no" />
          </h3>
        </div>
      );
    }

    return (
      <div
        className="uk-child-width-1-3@m uk-child-width-1-2@s"
        data-uk-grid="masonry: true"
      >
        {this.props.articles.map((article, key) => {
          return (
            <div key={key}>
              <ArticleView
                article={article}
                lang={
                  this.props.editing
                    ? this.props.language.edit
                    : this.props.language.view
                }
                editing={this.props.editing}
                buttonClass={this.props.buttonClass}
                buttonText={
                  this.props.buttonText && this.props.buttonText(article)
                }
                onClick={this.props.onClick}
              />
            </div>
          );
        })}
      </div>
    );
  };
}

const mapStateToProps = (state) => {
  return {
    language: state.language,
  };
};

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators({}, dispatch),
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ArticleCardsList),
);
